/**
 * Central OAuth callback on www for *.flairwizard.com tenants (one Reddit redirect URI).
 * Optional override: VITE_AUTH_ORIGIN=https://www.flairwizard.com
 */
export function getOAuthRedirectUri(): string {
  const origin = import.meta.env.VITE_AUTH_ORIGIN as string | undefined;
  if (origin?.trim()) {
    return `${origin.replace(/\/$/, '')}/auth/callback`;
  }
  if (typeof window !== 'undefined' && window.location.hostname.endsWith('.flairwizard.com')) {
    return 'https://www.flairwizard.com/auth/callback';
  }
  return `${window.location.origin}/auth/callback`;
}

/** Shared cookie domain for subdomains (e.g. .flairwizard.com). Empty = host-only. */
export function getSharedCookieDomain(): string {
  const h = window.location.hostname;
  if (h === 'localhost' || h === '127.0.0.1') return '';
  if (h.endsWith('.flairwizard.com')) return '.flairwizard.com';
  return '';
}

export function setSharedCookie(name: string, value: string, maxAgeSeconds: number): void {
  const domain = getSharedCookieDomain();
  const domainPart = domain ? `; domain=${domain}` : '';
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax${secure}${domainPart}`;
}

export function getSharedCookie(name: string): string | null {
  const key = `${encodeURIComponent(name)}=`;
  for (const part of document.cookie.split(';')) {
    const p = part.trim();
    if (p.startsWith(key)) return decodeURIComponent(p.slice(key.length));
  }
  return null;
}

export function deleteSharedCookie(name: string): void {
  const domain = getSharedCookieDomain();
  const domainPart = domain ? `; domain=${domain}` : '';
  document.cookie = `${encodeURIComponent(name)}=; path=/; max-age=0${domainPart}`;
}
